// extracted by mini-css-extract-plugin
export default {"Divider":"Divider_Divider__9y-7z"};